import { ref, watch, computed } from '@vue/composition-api'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'

export default function useBetsList(props) {
  // Use toast
  const playerData = props.playerData
  const toast = useToast()

  const refBetListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'betId',
    },
    {
      key: 'transactionId',
    },
    {
      key: 'player_name',
      label: 'Customer Details',
      formatter: title,
    },
    { 
      key: 'amount',
      sortable: true,
      label: 'Bet Amount',
      formatter: val => `KES ${Number(val).toLocaleString()}`
    },
    { 
      key: 'amount_won',
      label: 'Total Won',
      sortable: true,
      formatter: val => `KES ${Number(val).toLocaleString()}`
    },
    { 
      key: 'profit',
      sortable: true,
      formatter: val => `KES ${Number(val).toLocaleString()}`
    },
    {
      key: 'status',
      label: 'Status',
    },
    {
      key: 'created_at',
      sortable: true,
      label: "Placed On",
    },
    // {
    //   key: 'actions',
    // },
  ]
  const perPage = ref(10)
  const totalBets = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const isBusy = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refBetListTable.value ? refBetListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalBets.value,
    }
  })

  const refetchData = () => {
    refBetListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const fetchBets = (ctx, callback) => {
    isBusy.value = true
    store
      .dispatch('bets/fetchBets', {
        search: searchQuery.value,
        user_id: playerData == undefined ? '': playerData.id,
        page_size: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { data, paginator } = response.data

        callback(data)
        totalBets.value = paginator.length
        isBusy.value = false
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching bets' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveBetStatusVariantAndIcon = status => {
    if (status === 'Pending') return { variant: 'secondary', icon: 'PieChartIcon' }
    if (status === 'Won') return { variant: 'success', icon: 'CheckCircleIcon' }
    if (status === 'Cancelled') return { variant: 'primary', icon: 'XIcon' }
    if (status === 'Lost') return { variant: 'danger', icon: 'InfoIcon' }
    return { variant: 'secondary', icon: 'XIcon' }
  }
  const resolveBetAvatarVariant = status => {
    if (status === 'Pending') return 'secondary'
    if (status === 'Won') return 'success'
    if (status === 'Cancelled') return 'primary'
    if (status === 'Lost') return 'danger'
    return 'primary'
  }

  return {
    fetchBets,
    tableColumns,
    perPage,
    currentPage,
    totalBets,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refBetListTable,
    isBusy,

    statusFilter,

    resolveBetStatusVariantAndIcon,
    resolveBetAvatarVariant,
    refetchData,
  }
}
